import { render, staticRenderFns } from "./TrainingDialogTabsElectronic.vue?vue&type=template&id=8c017894&"
import script from "./TrainingDialogTabsElectronic.vue?vue&type=script&lang=js&"
export * from "./TrainingDialogTabsElectronic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports